/**
 * @generated SignedSource<<2c031650beae4430bf0b97f43bee8df5>>
 * @relayHash c3ab20eb8fb26330874bc2b291878b80
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3ab20eb8fb26330874bc2b291878b80

import type { ConcreteRequest } from 'relay-runtime';
export type DependenciesPickerRelationshipsQuery$variables = {
  id: string;
};
export type DependenciesPickerRelationshipsQuery$data = {
  readonly node: {
    readonly blockedBy?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      } | null | undefined> | null | undefined;
    };
    readonly blocking?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      } | null | undefined> | null | undefined;
    };
    readonly id?: string;
    readonly relatesTo?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
      } | null | undefined> | null | undefined;
    };
  } | null | undefined;
};
export type DependenciesPickerRelationshipsQuery = {
  response: DependenciesPickerRelationshipsQuery$data;
  variables: DependenciesPickerRelationshipsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v2/*:: as any*/)
    ],
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": (v3/*:: as any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blockedBy",
  "plural": false,
  "selections": (v4/*:: as any*/),
  "storageKey": "blockedBy(first:100)"
},
v6 = {
  "alias": null,
  "args": (v3/*:: as any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blocking",
  "plural": false,
  "selections": (v4/*:: as any*/),
  "storageKey": "blocking(first:100)"
},
v7 = {
  "alias": null,
  "args": (v3/*:: as any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "relatesTo",
  "plural": false,
  "selections": (v4/*:: as any*/),
  "storageKey": "relatesTo(first:100)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DependenciesPickerRelationshipsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DependenciesPickerRelationshipsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c3ab20eb8fb26330874bc2b291878b80",
    "metadata": {},
    "name": "DependenciesPickerRelationshipsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f6a10fc8bd4912934d3564c7654530da";

export default node;
